module.exports = __webpack_public_path__ + "static/media/drag.e7e1acd8.svg";